/* tutor-1 (C): EL CUADRO DE ESCRIBIR: la pildora (#0E0E0E, borde #262626, esquinas 22); el texto crece hasta 5
   renglones; las fotos elegidas como miniaturas de 56 con su "x"; abajo a la izquierda el clip; a la derecha el
   contador (Gratis e invitado, naranja en el ultimo) y el boton naranja de 36 que se vuelve "Detener" mientras
   contesta. Enter manda; Shift+Enter hace renglon. Debajo, el aviso "El tutor puede equivocarse".

   tutor-3 (B.3, P3): PEGAR una imagen (Ctrl+V, Cmd+V o el "Pegar" del menu del telefono) la mete como foto del
   mensaje por el MISMO camino de la camara (`alElegirFotos`: achicada en el aparato, tope de 10 con su aviso). Si el
   portapapeles trae imagenes, el pegado de texto se cancela; un pegado de puro texto no cambia.

   camara-pills (seccion 2, firma de Carlos 23-oct): el clip es el UNICO boton de adjuntar (la camara se fue). Su
   input acepta varios archivos y los reparte segun lo que elija el alumno (`repartirDelClip`): las imagenes van
   juntas, en UNA llamada, a `alElegirFotos` (fotos del mensaje: achicadas, miniaturas, tope de 10); lo demas va a
   `alElegirArchivo` uno por uno y en orden, esperando cada subida antes de empezar la siguiente (archivos de la
   conversacion, como antes).

   ARCHIVO EN ASCII A PROPOSITO. */
import React, { useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUp, Paperclip, Square, X } from 'lucide-react';
import { AreaDe44 } from '../panel/anatomia';

export const ACEPTA_DOCUMENTO = '.pdf,.docx,.pptx,.txt,image/jpeg,image/png,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';
export const ACEPTA_FOTOS = 'image/jpeg,image/png,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';
const ALTO_MAXIMO_PX = 140;
const EXTENSION_DE_IMAGEN = /\.(jpe?g|png|heic|heif)$/i;

/** camara-pills (2.2): imagen si su `type` empieza con image/; si el `type` viene vacio, por la extension. */
export function esImagen(archivo) {
  const tipo = String((archivo && archivo.type) || '');
  if (tipo) return tipo.startsWith('image/');
  return EXTENSION_DE_IMAGEN.test(String((archivo && archivo.name) || ''));
}

/** camara-pills (2.2): las imagenes juntas a `alElegirFotos`; los documentos a `alElegirArchivo`, uno tras otro. */
export async function repartirDelClip(archivos, alElegirFotos, alElegirArchivo) {
  const imagenes = archivos.filter(esImagen);
  const documentos = archivos.filter((f) => !esImagen(f));
  if (imagenes.length && alElegirFotos) alElegirFotos(imagenes);
  for (const archivo of documentos) {
    if (alElegirArchivo) await alElegirArchivo(archivo);
  }
}

/** tutor-3 (B.3): las imagenes de un evento `paste` (de `clipboardData.files` o, si no, de sus `items`). */
export function imagenesDelPegado(datos) {
  if (!datos) return [];
  const deArchivos = Array.from(datos.files || []).filter((f) => f && String(f.type || '').startsWith('image/'));
  if (deArchivos.length) return deArchivos;
  return Array.from(datos.items || [])
    .filter((it) => it && it.kind !== 'string' && String(it.type || '').startsWith('image/'))
    .map((it) => (typeof it.getAsFile === 'function' ? it.getAsFile() : null))
    .filter(Boolean);
}
const BOTON_REDONDO = 'relative w-9 h-9 rounded-full flex items-center justify-center text-[#9A9A9A] hover:bg-[#1B1B1B] hover:text-[#C8C8C8] disabled:opacity-45 shrink-0';

export default function Cuadro({
  valor, alCambiar, fotos = [], alQuitarFoto, alElegirFotos, alElegirArchivo, alMandar, alDetener,
  contestando = false, usados = 0, tope = null, apagado = false, conAviso = true, enfocarRef, abrirClipRef,
}) {
  const { t } = useTranslation('study');
  const textoRef = useRef(null);
  const archivoRef = useRef(null);
  if (enfocarRef) enfocarRef.current = () => textoRef.current && textoRef.current.focus();
  if (abrirClipRef) abrirClipRef.current = () => archivoRef.current && archivoRef.current.click();

  useLayoutEffect(() => {
    const el = textoRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, ALTO_MAXIMO_PX)}px`;
  }, [valor]);

  const puedeMandar = !apagado && !contestando && String(valor || '').trim().length > 0;
  const alTeclear = (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !e.nativeEvent?.isComposing) {
      e.preventDefault();
      if (puedeMandar) alMandar();
    }
  };
  const ultimo = tope != null && usados >= tope - 1;
  const alPegar = (e) => {
    const imagenes = imagenesDelPegado(e.clipboardData);
    if (!imagenes.length) return;
    e.preventDefault();
    if (!apagado && !contestando && alElegirFotos) alElegirFotos(imagenes);
  };

  return (
    <div className="shrink-0 pt-2 md:pt-2.5" data-testid="tutor-cuadro-envoltura">
      <div className="rounded-[22px] bg-[#0E0E0E] border border-[#262626] focus-within:border-[#3a3a3a] pl-4 pr-2.5 pt-2.5 pb-2 grid gap-1.5 transition-colors"
        data-testid="tutor-cuadro">
        {fotos.length ? (
          <div className="flex flex-wrap gap-2.5 pt-1 pb-0.5">
            {fotos.map((f, i) => (
              <span key={f.id} className="relative w-14 h-14 rounded-[10px] border border-[#2C2C2C] bg-[#181818]" data-testid="tutor-foto-elegida">
                <img src={f.url} alt={t('tutor.photos.label', { n: i + 1 })} className="w-full h-full object-cover rounded-[10px]" />
                <button type="button" onClick={() => alQuitarFoto(f.id)} aria-label={t('tutor.photos.remove')} title={t('tutor.photos.remove')}
                  className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-[#2E2E2E] border border-[#2C2C2C] text-[#F4F4F3] flex items-center justify-center"
                  data-testid="tutor-quitar-foto">
                  <AreaDe44 />
                  <X className="w-2.5 h-2.5" aria-hidden="true" />
                </button>
              </span>
            ))}
          </div>
        ) : null}
        <textarea ref={textoRef} rows={1} value={valor} onChange={(e) => alCambiar(e.target.value)} onKeyDown={alTeclear} onPaste={alPegar}
          placeholder={t('tutor.composer.placeholder')} disabled={apagado} maxLength={4000}
          className="w-full resize-none border-0 bg-transparent text-[#F4F4F3] text-[15px] leading-[1.5] outline-none py-1 min-h-[30px] placeholder:text-[#6F6F6F]"
          style={{ maxHeight: ALTO_MAXIMO_PX }} data-testid="tutor-texto" />
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1 min-w-0">
            <button type="button" className={BOTON_REDONDO} onClick={() => archivoRef.current && archivoRef.current.click()}
              disabled={apagado || contestando} aria-label={t('tutor.composer.doc')} title={t('tutor.composer.doc')} data-testid="tutor-clip">
              <AreaDe44 />
              <Paperclip className="w-[18px] h-[18px]" aria-hidden="true" />
            </button>
            <input ref={archivoRef} type="file" accept={ACEPTA_DOCUMENTO} multiple className="hidden" data-testid="tutor-input-archivo"
              onChange={(e) => {
                const elegidos = Array.from(e.target.files || []);
                e.target.value = '';
                if (elegidos.length) repartirDelClip(elegidos, alElegirFotos, alElegirArchivo);
              }} />
          </div>
          <div className="flex items-center gap-1 min-w-0">
            {tope != null ? (
              <span className={`text-[12px] mr-1.5 whitespace-nowrap tabular-nums ${ultimo ? 'text-[#F7A06A]' : 'text-[#9A9A9A]'}`}
                data-testid="tutor-contador" data-ultimo={ultimo ? 'true' : 'false'}>
                {t('tutor.composer.counter', { used: usados, limit: tope })}
              </span>
            ) : null}
            {contestando ? (
              <button type="button" onClick={alDetener} aria-label={t('tutor.composer.stop')} title={t('tutor.composer.stop')}
                className="relative w-9 h-9 rounded-full bg-[#F27A2E] text-[#160A02] flex items-center justify-center shrink-0" data-testid="tutor-detener">
                <AreaDe44 />
                <Square className="w-3.5 h-3.5" fill="currentColor" aria-hidden="true" />
              </button>
            ) : (
              <button type="button" onClick={alMandar} disabled={!puedeMandar} aria-label={t('tutor.composer.send')} title={t('tutor.composer.send')}
                className="relative w-9 h-9 rounded-full bg-[#F27A2E] text-[#160A02] flex items-center justify-center shrink-0 disabled:opacity-45"
                data-testid="tutor-enviar">
                <AreaDe44 />
                <ArrowUp className="w-[18px] h-[18px]" aria-hidden="true" />
              </button>
            )}
          </div>
        </div>
      </div>
      {conAviso ? (
        <div className="text-center text-[12px] text-[#6F6F6F] pt-2" data-testid="tutor-aviso">{t('tutor.composer.disclaimer')}</div>
      ) : null}
    </div>
  );
}
